module.exports = __webpack_public_path__ + "static/media/alert.bfe8e3e3.svg";